import request from '@/util/request'
import store from '../store/store'
let ready = false

export function isIOS () {
  let isIphone = navigator.userAgent.includes('iPhone')
  let isIpad = navigator.userAgent.includes('iPad')
  return isIphone || isIpad
}
export async function requestWxstr () {
  let uri = window.location.href
  // alert(uri)
  let res = await queryWxStr(uri.split('#')[0])
  store.commit('set_app_id', res.appID)
  console.log('wxstr', uri.split('#')[0])
  // eslint-disable-next-line no-undef
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: res.appID, // 必填，公众号的唯一标识
    timestamp: '' + res.timestamp, // 必填，生成签名的时间戳
    nonceStr: res.nonce_str, // 必填，生成签名的随机串
    signature: res.signature, // 必填，签名
    jsApiList: [ 'checkJsApi', 'scanQRCode' ], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-subscribe'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  })
  // 阻止第二次调用
  // eslint-disable-next-line no-undef
  wx.ready((res) => {
    console.log('wxres', res)
    ready = true
  })
  // eslint-disable-next-line no-undef
  wx.error((err) => {
    console.log('wxerr', err)
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  })
}
export function queryWxStr (uri) {
  let url = ''
  let host = window.location.host
  if (host === 'aimtycloud.anfangwx.aimtyiot.cn') {
    url = window.location.protocol + '//wx.aimtyiot.cn/wx1/js'
  } else if (host === 'anfangwxtest.aimtyiot.cn') {
    url = window.location.protocol + '//wx.aimtyiot.cn/wx2/js'
  } else {
    url = window.location.protocol + '//wx.aimtyiot.cn/wx/js'
  }
  return request({
    url: url,
    method: 'get',
    params: { uri }
  })
}

export function isReady () {
  return ready
}



// WEBPACK FOOTER //
// ./src/api/scanCode.js